import { Component } from '@angular/core';
import { TranslatePipe } from '@codeandweb/ngx-translate';

@Component({
  selector: 'app-about',
  imports: [TranslatePipe],
  templateUrl: './about.html',
  styleUrl: './about.scss'
})
export class About {}
